import { PlusIcon } from "@heroicons/react/24/outline";
import type { PropsWithChildren } from "react";

import type { ButtonNewItemVariantProps } from "~/components/buttons/ButtonNewItem/buttonNewItemVariants.ts";
import { buttonNewItemVariants } from "~/components/buttons/ButtonNewItem/buttonNewItemVariants.ts";
import type { HeroIconType } from "~/types/heroIconTypes.ts";

type Props = ButtonNewItemVariantProps & {
	onClick: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
	disabled?: boolean;
	icon?: HeroIconType;
}

const ButtonNewItem: React.FC<PropsWithChildren<Props>> = ({
	onClick,
	disabled = false,
	icon,
	size = "default",
	theme,
	rounded,
	children,
}) => {
	const { button, icon: iconVariants } = buttonNewItemVariants({ disabled, size, theme, rounded });
	const Icon = icon ?? PlusIcon;
	return (
		<button
			type="button"
			className={button()}
			onClick={onClick}
			disabled={disabled}
		>
			<Icon
				className={iconVariants()}
			/>
			{children && <div className="text-sm font-medium">{children}</div>}
		</button>
	);
};

export default ButtonNewItem;
